'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var autoDetectResource = require('./autoDetectResource.js');
var ArrayResource = require('./ArrayResource.js');
var BufferResource = require('./BufferResource.js');
var CanvasResource = require('./CanvasResource.js');
var CubeResource = require('./CubeResource.js');
var ImageResource = require('./ImageResource.js');
var SVGResource = require('./SVGResource.js');
var VideoResource = require('./VideoResource.js');
var ImageBitmapResource = require('./ImageBitmapResource.js');
var Resource = require('./Resource.js');
var BaseImageResource = require('./BaseImageResource.js');
var AbstractMultiResource = require('./AbstractMultiResource.js');

autoDetectResource.INSTALLED.push(ImageBitmapResource.ImageBitmapResource, ImageResource.ImageResource, CanvasResource.CanvasResource, VideoResource.VideoResource, SVGResource.SVGResource, BufferResource.BufferResource, CubeResource.CubeResource, ArrayResource.ArrayResource);

exports.INSTALLED = autoDetectResource.INSTALLED;
exports.autoDetectResource = autoDetectResource.autoDetectResource;
exports.ArrayResource = ArrayResource.ArrayResource;
exports.BufferResource = BufferResource.BufferResource;
exports.CanvasResource = CanvasResource.CanvasResource;
exports.CubeResource = CubeResource.CubeResource;
exports.ImageResource = ImageResource.ImageResource;
exports.SVGResource = SVGResource.SVGResource;
exports.VideoResource = VideoResource.VideoResource;
exports.ImageBitmapResource = ImageBitmapResource.ImageBitmapResource;
exports.Resource = Resource.Resource;
exports.BaseImageResource = BaseImageResource.BaseImageResource;
exports.AbstractMultiResource = AbstractMultiResource.AbstractMultiResource;
//# sourceMappingURL=index.js.map
